// Replace each value with the real numeric slot ID from the AdSense dashboard
// (Ads -> By ad unit -> Display ads). Until then, ads will not render in
// production but the placements are reserved.

export const AD_SLOTS = {
    LAYOUT_TOP: '0000000001',
    LAYOUT_BOTTOM: '0000000002',

    HOME_HERO: '0000000010',
    HOME_MID: '0000000011',

    WORD_TO_PDF: '0000000020',
    IMAGE_TO_PDF: '0000000021',
    COMPRESS_PDF: '0000000022',
    PDF_TO_IMAGE: '0000000023',
    PDF_TO_WORD: '0000000024',

    BLOG_INDEX: '0000000030',
    BLOG_POST_TOP: '0000000031',
    BLOG_POST_BOTTOM: '0000000032',
};
